export default __webpack_public_path__ + "static/media/portfolio2.32fdae28.jpg";